app.directive('d3Bars', ['d3Service', '$rootScope', function (d3Service, rootScope) {
    return {
        restrict: 'EA',
        scope: {
            data: "=",
            logo: "=",
            label: "@",
            onClick: "&"
        },
        link: function (scope, iElement, iAttrs) {

            scope.data = convertdata(scope.data);

            scope.$watch("data", function (newValue, oldValue) {
                scope.data = convertdata(newValue);
                var evt = new MouseEvent("mousedown");
                var circles = d3.select('#current').node();
                if (circles)
                    circles.dispatchEvent(evt);
            });


            d3Service.d3().then(function (d3) {

                // https://github.com/wbkd/d3-extended
                d3.selection.prototype.moveToFront = function () {
                    return this.each(function () {
                        this.parentNode.appendChild(this);
                    });
                };
                d3.selection.prototype.moveToBack = function () {
                    return this.each(function () {
                        var firstChild = this.parentNode.firstChild;
                        if (firstChild) {
                            this.parentNode.insertBefore(this, firstChild);
                        }
                    });
                };


                /**
                 * Add svg in the element html
                 * @type {number}
                 */
                var image_width = 200,
                    image_height = 30;
                var width = 320,
                    height = 350,
                    // radius = Math.min(width, height) / 2,
                    radius = Math.min(width, height) / 2 - 10;
                var svg = d3.select(iElement[0])
                    .append("svg")
                    .attr('width', width)
                    .attr('height', height)
                    .append('g')
                    // .attr('transform', 'translate(' + (width - radius) + ',' + (height - radius) + ')').attr('viewBox', (-width / 2) + ' ' + (-height / 2) + ' ' + width + ' ' + height)
                    .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
                // .attr('preserveAspectRatio', 'xMinYMin');
                /**
                 * Add image in the center of pie chart
                 */
                svg.append('image')
                    .attr('class', 'image-center')
                    .attr("x", -1 * 80 / 2)
                    .attr("y", -1 * 80 / 2)
                    .attr("width", 80)
                    .attr("height", 80)
                    .attr("xlink:href", scope.logo);
                // on window resize, re-render d3 canvas
                window.onresize = function () {
                    return scope.$apply();
                };
                scope.$watch(function () {
                    return angular.element(window)[0].innerWidth;
                }, function () {
                    return scope.render(scope.data);
                }
                );
                // var colorInitial = '#f7f7f7';
                // var colorMouseOver = "#164fc2";
                var arc = d3.svg.arc()
                    .outerRadius(function (d, index) {
                        return radius;
                    })
                    .innerRadius(100);
                var arcOver = d3.svg.arc()
                    .innerRadius(100)
                    .outerRadius(radius + 10);
                // watch for data changes and re-render
                scope.$watch('data', function (newVals, oldVals) {
                    return scope.render(newVals);
                }, true);
                scope.execute = function execute(d, index) {
                    d3.selectAll('.arc').each(function (d, i) {
                        d3.select(this).select('path').transition()
                            .ease("bounce")
                            .duration(200)
                            .attr("d", arc)
                            .style('stroke', 'white')
                            .attr("stroke-width", 2);

                    });
                    d3.selectAll('.arc').each(function (d, i) {
                        d3.select(this).select("path").attr("class", "hover-none");
                        d3.select(this).select("g").selectAll('rect').remove();
                        d3.select(this).select("g").selectAll('text').remove();
                        // d3.select(this.parentNode).select(".image-hover").remove();
                    });

                    if (d3.event.type === 'mousedown') {
                        d3.selectAll('.arc-current').each(function (d, i) {
                            d3.select(this).attr("class", "arc");
                            d3.select(this).select('path').attr('class', 'hover-none').transition()
                                .ease("bounce")
                                .duration(200)
                                .attr("d", arc)
                                .style('stroke', 'white')
                                .attr("stroke-width", 2);
                            d3.select(this).select("g").selectAll('rect').remove();
                            d3.select(this).select("g").selectAll('text').remove();
                        });
                        rootScope.$broadcast('dj3', index);
                        d3.select(this.parentNode).attr("class", "arc-current").moveToFront();
                    }
                    /**
                     *  ok pour faire le hover radius
                     */
                    d3.select(this).transition()
                        .ease("bounce")
                        .attr("class", "hover")
                        .duration(200)
                        .attr("d", arcOver)
                        .style('stroke', 'white')
                        .attr("stroke-width", 2);
                    var textWidthTAB = [];
                    if (d3.select(this.parentNode).classed('arc') || d3.event.type === 'mouseenter') {
                        d3.selectAll('.arc-current').each(function (d, i) {
                            d3.select(this).select("g").selectAll('rect').remove();
                            d3.select(this).select("g").selectAll('text').remove();
                            d3.select(this).select("g").selectAll('.image-hover').remove();
                        });
                        d3.selectAll('.arc').each(function (d, i) {
                            d3.select(this).select("g").selectAll('rect').remove();
                            d3.select(this).select("g").selectAll('text').remove();
                            d3.select(this).select("g").selectAll('.image-hover').remove();

                        });
                        d3.select(this.parentNode).select(".text")
                            .append('text')
                            .text(function (d) {
                                return d.data.label;
                            })
                            .each(function (d, i) {
                                var thisWidth = this.getComputedTextLength();
                                textWidthTAB.push(thisWidth);
                            }).remove();
                        var calc = d.startAngle / 2 - Math.PI / 2;
                        var position = "start";

                        var rec = d3.select(this.parentNode).moveToFront()
                            .select(".text")
                            .append('rect')
                            // .attr("fill", '#f7f7f7')
                            .attr("width", function (d, i) {
                                return textWidthTAB[i] + 50;
                            })
                            .attr("height", "30px")
                            .attr("rx", "15")
                            .attr("ry", "15")
                            .attr('pointer-events', 'none');

                        if (Math.sign(calc) === 1) {
                            rec.attr('x', -15)
                                .attr('y', -15)
                                .attr('dx', -50)
                                .attr('dy', -15);
                        } else {
                            rec.attr('x', function (d, i) {
                                return -(textWidthTAB[i] + 30);
                            })
                                .attr('y', -15)
                                .attr('dx', -50)
                                .attr('dy', -15);
                        }
                        var text = d3.select(this.parentNode).moveToFront().select(".text")
                            .append('text')
                            .attr("fill", "white")
                            .attr('class', 'label')
                            .attr('pointer-events', 'none')
                            .text(function (d) {
                                return d.data.label;
                            })
                            .each(function (d, i) {
                                var thisWidth = this.getComputedTextLength();
                                textWidthTAB.push(thisWidth);
                            })
                            .attr('text-anchor', function () {
                                if (Math.sign(calc) === 1) {
                                    position = "start";
                                } else {
                                    position = "end";
                                }
                                return position;
                            });
                        if (Math.sign(calc) === 1) {
                            text.attr('x', 20)
                                .attr('y', 5);
                        } else {
                            text.attr('x', -20)
                                .attr('y', 5);
                        }
                    }

                    d3.select(this.parentNode).select(".text").attr('class', 'text')
                        .attr("transform", function (d) {
                            return "translate(" + arc.centroid(d) + ")";
                        })
                        .append("svg:image").attr('class', 'image-hover')
                        .attr('pointer-events', 'none')
                        .attr("xlink:href", function (d) {
                            return d.data.logo;
                        })
                        .attr("width", image_width)
                        .attr("height", image_height)
                        .attr("x", -1 * image_width / 2)
                        .attr("y", -1 * image_height / 2);

                };
                // define render function
                scope.render = function (data) {
                    var piedata = scope.data;
                    var pie = d3.layout.pie()
                        .value(function (d) {
                            return d.percent * 4 + 22;
                        });
                    var arcs = svg.selectAll(".arc")
                        .data(pie(piedata))
                        .enter().append("g")
                        .attr("class", "arc");
                    d3.selectAll('.arc').each(function (d, i) {
                        if (i === 0) {
                            d3.select(this).select('path').attr('id', 'current').attr('data-id', i);
                        } else {
                            d3.select(this).select('path').attr('class', 'hover-none').attr('data-id', i)
                                .attr("stroke-width", 2).style('stroke', 'white');
                        }
                    });
                    arcs.append("path").attr('class', 'hover-none')
                        .attr('class', 'image')
                        .style('cursor', 'pointer')
                        .on("mousedown", scope.execute)
                        .on("mouseenter", scope.execute)
                        .on("mouseleave", function () {
                            d3.select(".arc-current").moveToFront();
                            d3.selectAll('.arc').each(function (d, i) {
                                d3.select(this).attr("class", "arc");
                                d3.select(this).select('path').attr('class', 'hover-none').transition()
                                    .ease("bounce")
                                    .duration(200)
                                    .attr("d", arc)
                                    .style('stroke', 'white')
                                    .attr("stroke-width", 2);
                                d3.select(this).select("g").selectAll('rect').remove();
                                d3.select(this).select("g").selectAll('text').remove();
                            });
                        })
                        .transition()
                        .ease("bounce")
                        .duration(500)
                        .attrTween("d", tweenPie);

                    arcs.append("g")
                        .attr('class', 'text')
                        .attr('text-anchor', "right")
                        .attr("transform", function (d) {
                            return "translate(" + arc.centroid(d) + ")";
                        })
                        .append("svg:image")
                        .attr('class', 'image')
                        .attr('pointer-events', 'none')
                        .attr("xlink:href", function (d) {
                            return d.data.logo;
                        })
                        .attr("width", image_width)
                        .attr("height", image_height)
                        .attr("x", -1 * image_width / 2)
                        .attr("y", -1 * image_height / 2);

                    function tweenPie(b) {
                        b.innerRadius = 0;
                        var i = d3.interpolate({ startAngle: 0, endAngle: 0 }, b);
                        return function (t) {
                            return arc(i(t));
                        };
                    }

                    Math.sign = Math.sign || function (x) {
                        x = +x; // convert to a number
                        if (x === 0 || isNaN(x)) {
                            return Number(x);
                        }
                        return x > 0 ? 1 : -1;
                    }
                };
                setTimeout(function () {
                    (function (window) {
                        try {

                            // return false; // No need to polyfill
                        } catch (e) {
                            // Need to polyfill - fall through
                        }

                        // Polyfills DOM4 MouseEvent
                        var MouseEvent = function (eventType, params) {
                            params = params || { bubbles: false, cancelable: false };
                            var mouseEvent = document.createEvent('MouseEvent');
                            mouseEvent.initMouseEvent(eventType, params.bubbles, params.cancelable, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                            return mouseEvent;
                        }

                        MouseEvent.prototype = Event.prototype;
                        window.MouseEvent = MouseEvent;
                    })(window);
                    var evt = new MouseEvent("mousedown");
                    var circles = d3.select('#current').node();
                    circles.dispatchEvent(evt);

                }, 200);
                scope.$on('select-d3js', function (event, data) {
                    var evt = new MouseEvent("mousedown");
                    var circles = d3.select('[data-id="' + data.index + '"]').node();
                    circles.dispatchEvent(evt);
                });

            });

        }

    };
}]
);





function convertdata(oldData) {

    if (oldData.length > 0 && oldData[0].name) {
        var datas = [];
        for (var i = 0; i < oldData.length; i++) {
            var newvalue = {};
            if (i == 0)
                newvalue.current = true;
            else
                newvalue.current = false;
            //  newvalue.styles = {};
            //   newvalue.label = oldData[i].custom[0];
            //newvalue.text = oldData[i].name;
            if (oldData[i].name.length > 25)
                newvalue.label = oldData[i].name.substr(0, 25) + '...';
            else
                newvalue.label = oldData[i].name
            newvalue.fulllabel = oldData[i].name;
            //   newvalue.number = oldData[i].value;
            // newvalue.item = 0;
            //   newvalue.quantity = oldData[i].custom[3];
            //   newvalue.className = oldData[i].image;
            //   newvalue.styles.top = oldData[i].custom[1];
            //    newvalue.styles.left = oldData[i].custom[2];
            newvalue.count = oldData[i].value;
            newvalue.percent = oldData[i].custom[3];

            newvalue.logo = 'www/assets/img/picto/' + oldData[i].custom[0] + '.png',
                newvalue.custom = oldData[i].custom;
            datas.push(newvalue);
        }
        return datas;
    }
    else
        return oldData;

}